<template>
  <b-button
    @click="onClick"
    class="btn d-block float-left btn-chung ml-1 mr-1"
    :disabled="disabled"
    :class="color || getClass()"
  >
    <font-awesome-icon
      v-if="getIcon() == 'save'"
      :icon="getIcon()"
    ></font-awesome-icon>
    <b-icon
      v-if="icon == 'none' || getIcon() == 'save' ? false : getIcon()"
      :icon="icon || getIcon()"
    />
    {{ button }}
  </b-button>
</template>

<script>
export default {
  name: "BaseButton",
  components: {},
  props: {
    button: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
    getClass() {
      switch (this.button) {
        case "Tìm kiếm":
          return "btn-primary btn-blue";
        case "Thêm mới đơn vị":
        case "Thêm mới cán bộ":
        case "Thêm vai trò":
        case "Thêm tỉnh thành":
        case "Thêm nhóm người dùng":
        case "Tạo mới":
        case "Sửa":
        case "Tạo":
        case "Lưu":
        case "Thêm mới":
          return "btn-success btn-green";
        case "Import":
          return "btn-primary btn-blue";
        case "Bỏ qua":
          return "btn-warning btn-yellow";
        // Green (btn-success): xác nhận/kích hoạt/lưu chính - bao gồm cả nhóm OTP QTHT.
        case "Cập nhật":
        case "Xác nhận":
        case "Đồng ý":
        case "Lưu cấu hình":
        case "Đăng ký":
        case "Kích hoạt":
        case "Xác thực":
        case "Xác nhận kích hoạt lại":
        case "Xác nhận mã":
        case "Đăng nhập":
        case "Xác nhận kích hoạt thiết bị này":
        case "Xác nhận bật lại": // OFF 2FA per-user (Approach A): bật lại 2FA - đối xứng "Xác nhận kích hoạt lại".
          return "btn-success btn-green";
        // Red (btn-danger): destructive - xoá hoặc reset 2FA (OTP QTHT).
        case "Đóng":
        case "Hủy":
        case "Xóa quyền đã chọn":
        case "Xóa vai trò đã chọn":
        case "Xóa nhóm người dùng đã chọn":
        case "Xóa":
        case "Xác nhận reset":
        case "Xác nhận vô hiệu": // OFF 2FA per-user (Approach A): vô hiệu 2FA - cùng nhóm destructive.
          return "btn-danger btn-red";
        // Excel palette xanh lá đậm (baseline template) - dùng chung cho Tải file Template + Xuất Excel.
        case "Tải file Template":
        case "Xuất Excel":
          return "btn-excel";
        // Yellow (btn-warning): download variant secondary - Xuất PDF OTP.
        case "Xuất PDF":
          return "btn-warning btn-yellow";
      }
      return null;
    },
    getIcon() {
      switch (this.button) {
        case "Tìm kiếm":
          return "search";
        case "Thêm mới đơn vị":
        case "Thêm mới cán bộ":
        case "Tạo mới":
        case "Thêm vai trò":
        case "Thêm tỉnh thành":
        case "Thêm nhóm người dùng":
        case "Thêm mới quyền":
        case "Thêm người dùng":
        case "Tạo":
        case "Thêm mới":
          return "plus-circle-fill";
        case "Import":
          return "box-arrow-in-down-left";
        case "Đóng":
        case "Bỏ qua":
          return "x-circle-fill";
        case "Đồng ý":
        case "Xác nhận":
          return "check-circle-fill";
        case "Xóa vai trò đã chọn":
        case "Xóa nhóm người dùng đã chọn":
        case "Xóa quyền đã chọn":
        case "Xóa":
          return "trash-fill";
        case "Làm mới":
          return "arrow-clockwise";
        case "Export":
          return "box-arrow-up-right";
        case "Export thông tin in thẻ":
          return "box-arrow-up-right";
        case "Hủy":
          return "arrow-repeat";
        case "Sửa":
        case "Cập nhật":
          return "pencil-square";
        // Download icon: Tải file Template + 2 nút export OTP (Xuất Excel / Xuất PDF).
        case "Tải file Template":
        case "Xuất Excel":
        case "Xuất PDF":
          return "download";
        // Save icon: Lưu + Lưu cấu hình OTP.
        case "Lưu":
        case "Lưu cấu hình":
          return "save";
        // Check-circle icon: các label green OTP (Đăng ký / Kích hoạt / Xác thực / ...).
        case "Đăng ký":
        case "Kích hoạt":
        case "Xác thực":
        case "Xác nhận reset":
        case "Xác nhận kích hoạt lại":
        case "Xác nhận mã":
        case "Đăng nhập":
        case "Xác nhận kích hoạt thiết bị này":
        case "Xác nhận bật lại": // OFF 2FA per-user (Approach A): đối xứng icon check.
        case "Xác nhận vô hiệu":
          return "check-circle-fill";
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-chung {
  border: none;
  height: 36px;
  border-radius: 3px;
  text-transform: inherit;
  background-color: #5a8dee;
  color: white;
}

.btn-success {
  background-color: #28c76f !important;
}
.btn-primary {
  background-color: #5a8dee !important;
}
.btn-warning {
  background-color: #f6d00b !important;
}
.btn-danger {
  background-color: #ea5455 !important;
}
.btn-chung.disabled {
  background-color: gray !important;
}
.btn-excel {
  background-color: #2cb566 !important;
}
</style>
